import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Plant } from 'src/app/core/models/plants';
import { PlantsService } from 'src/app/core/services/plants.service';

@Component({
  selector: 'app-dialog-plants',
  templateUrl: './dialog-plants.component.html',
  styleUrls: ['./dialog-plants.component.scss']
})
export class DialogPlantsComponent implements OnInit {

  @ViewChild('myTable') myTable: MatTable<any>;

  public myControl = new FormControl();
  public Plants: Array<Plant>;
  public customPlants: Array<string>;
  public selectedPlants: Array<Plant>;
  public form: FormGroup;
  public filteredOptions: Observable<string[]>;
  public displayedColumns: string[] = ['code', 'name', 'society', 'opcion'];
  public error: boolean = false;

  constructor(
    private _plantsService: PlantsService,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<DialogPlantsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { plants: Plant[], service: Plant[] }
  ) {
    this.form = this.formBuilder.group({
      name: ""
    });
    this.selectedPlants = new Array<Plant>();
    this.customPlants = new Array<string>();
    this.Plants = new Array<Plant>();
  }

  private _filter(value: string): string[] {

    this.error = false;

    const filterValue = value.toLowerCase();

    return this.customPlants.filter(option => option.toLowerCase().includes(filterValue));
  }

  ngOnInit(): void {
    let withData = false;
    if (this.data.plants) {
      withData = true;
    }

    this.Plants = this.data.service;
    this.Plants.forEach(x => {
      this.customPlants.push(x.code + " - " + x.name);
    });
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
    );
    if (withData) {
      this.data.plants.forEach(x => {
        this.selectedPlants.push(x);
      });
      try {
        this.myTable.renderRows();
      } catch (e) { }
    }

  }

  public add() {
    let repeated = false;
    if (this.selectedPlants.length > 0) {
      this.selectedPlants.forEach(x => {
        if ((x.code + " - " + x.name) == this.myControl.value) {
          this.error = true;
          repeated = true;
        }
      });
    }

    if (!repeated) {
      this.error = false;
      let found = false;
      this.Plants.forEach(x => {
        if ((x.code + " - " + x.name) == this.myControl.value) {
          found = true;
          this.selectedPlants.push(x);
          this.selectedPlants = this.selectedPlants.reverse(); 
          if (this.selectedPlants.length > 0) {
            try {
              this.myTable.renderRows();
            } catch (e) {
              this.myControl.patchValue("");
            }
          }
        }
      });
      if (found) {
        this.myControl.patchValue("");
      }
    }
  }

  public delete(position: number) {
    this.selectedPlants.splice(position, 1);
    this.myTable.renderRows();
  }

  public asign() {
    this.dialogRef.close(this.selectedPlants);
  }
}
